import styled from 'styled-components';

const CategoriesStyle = styled.section`
	--sizeImage: 9.5vw;
	--distanceCategoriesGap: var(--sp4x);
	--distanceTitleContent: var(--sp9x);
	--widthItem: 20vw;

	.wrapper-data-categories {
		overflow: hidden;
		display: flex;
		flex-direction: column;
		gap: var(--distanceCategoriesGap);
		margin-bottom: var(--sectionDistance);
	}

	.wrapper-title {
		margin-bottom: var(--distanceTitleContent);
		margin-right: var(--contPaddingLR);
		margin-left: var(--contPaddingLR);
	}

	.data-wrapper {
		width: fit-content;
		display: flex;
		gap: var(--distanceCategoriesGap);
		will-change: transform;
	}

	.wrapper-down {
		position: relative;
		height: calc(var(--sizeImage) + 2px);
	}

	.down-data {
		position: absolute;
		right: 0;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceCategoriesGap: var(--sp3x);
		--sizeImage: 10.938vw;
		--distanceTitleContent: var(--sp6x);
		--widthItem: 20.938vw;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeImage: 10.4vw;
		--widthItem: 20.5vw;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceCategoriesGap: var(--sp2-5x);
		--sizeImage: 10.25vw;
		--distanceTitleContent: var(--sp4x);
		--widthItem: 20.938vw;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeImage: 11vw;
		--widthItem: 21.6vw;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceCategoriesGap: var(--sp2x);
		--sizeImage: 10.5vw;
		--widthItem: 21.4vw;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceCategoriesGap: var(--sp1x);
		--sizeImage: 24.13vw;
		--distanceTitleContent: var(--sp3x);
		--widthItem: 45.61vw;

		.wrapper-data-categories {
			gap: var(--sp2x);
		}
	}
`;
export default CategoriesStyle;
